import "core-js/modules/es.symbol";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.sort";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.string.search";
import "core-js/modules/es.string.starts-with";
import "core-js/modules/web.dom-collections.for-each";
import _defineProperty from "/Users/suifeng/Desktop/projects/2026/Temperature/TempAdmin/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { articleList, articleHandle, articleDelete, articleChannelList, articleChannelHandle, articleChannelDelete } from '@/api/apis';
import upload from '@/plugin/upload';
import d2Ueditor from '@/components/d2-ueditor';
export default {
  name: 'articleManager',
  data: function data() {
    return {
      activeTab: 'article',
      search: {
        channel_id: '',
        status: '',
        title: ''
      },
      channelOptions: [],
      // 文章列表
      articleLoading: false,
      articleData: [],
      articlePage: 1,
      articleSize: 10,
      articleTotal: 0,
      // 频道列表
      channelLoading: false,
      channelData: [],
      channelPage: 1,
      channelSize: 10,
      channelTotal: 0,
      // 文章弹窗
      articleDialogVisible: false,
      articleSubmitLoading: false,
      articleForm: {
        id: '',
        channel_id: '',
        title: '',
        cover: '',
        desc: '',
        content: '',
        is_recommend: 0,
        status: 1,
        sort: 0
      },
      articleRules: {
        title: [{
          required: true,
          message: '请输入文章标题',
          trigger: 'blur'
        }],
        channel_id: [{
          required: true,
          message: '请选择所属频道',
          trigger: 'change'
        }]
      },
      // 频道弹窗
      channelDialogVisible: false,
      channelSubmitLoading: false,
      channelForm: {
        id: '',
        name: '',
        sort: 0,
        is_show: 1,
        is_recommend: 0
      },
      channelRules: {
        name: [{
          required: true,
          message: '请输入频道名称',
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.loadChannelList().then(function () {
      _this.loadArticleList();
    });
  },
  methods: {
    onTabClick: function onTabClick() {
      if (this.activeTab === 'article') {
        this.loadArticleList();
      } else {
        this.loadChannelList();
      }
    },
    // 频道列表
    loadChannelList: function loadChannelList() {
      var _this2 = this;

      this.channelLoading = true;
      return articleChannelList({
        page: this.channelPage,
        limit: this.channelSize,
        where: {}
      }).then(function (res) {
        _this2.channelData = res && res.rows || [];
        _this2.channelTotal = res && res.count || 0;
        _this2.channelOptions = _this2.channelData.map(function (item) {
          return {
            id: item.id,
            name: item.name
          };
        });
        _this2.channelLoading = false;
      }).catch(function () {
        _this2.channelData = [];
        _this2.channelTotal = 0;
        _this2.channelLoading = false;
      });
    },
    onChannelPageChange: function onChannelPageChange(page) {
      this.channelPage = page;
      this.loadChannelList();
    },
    onChannelSizeChange: function onChannelSizeChange(size) {
      this.channelSize = size;
      this.channelPage = 1;
      this.loadChannelList();
    },
    // 文章列表
    loadArticleList: function loadArticleList() {
      var _this3 = this;

      this.articleLoading = true;
      var where = {};
      if (this.search.channel_id !== '') where.channel_id = this.search.channel_id;
      if (this.search.status !== '') where.status = this.search.status;
      if (this.search.title) where.title = this.search.title;
      articleList({
        page: this.articlePage,
        limit: this.articleSize,
        where: where
      }).then(function (res) {
        _this3.articleData = res && res.rows || [];
        _this3.articleTotal = res && res.count || 0;
        _this3.articleLoading = false;
      }).catch(function () {
        _this3.articleData = [];
        _this3.articleTotal = 0;
        _this3.articleLoading = false;
      });
    },
    onArticlePageChange: function onArticlePageChange(page) {
      this.articlePage = page;
      this.loadArticleList();
    },
    onArticleSizeChange: function onArticleSizeChange(size) {
      this.articleSize = size;
      this.articlePage = 1;
      this.loadArticleList();
    },
    onArticleReset: function onArticleReset() {
      this.search = {
        channel_id: '',
        status: '',
        title: ''
      };
      this.articlePage = 1;
      this.loadArticleList();
    },
    // 文章新增/编辑
    onAdd: function onAdd() {
      var _this4 = this;

      this.articleForm = {
        id: '',
        channel_id: '',
        title: '',
        cover: '',
        desc: '',
        content: '',
        is_recommend: 0,
        status: 1,
        sort: 0
      };
      this.articleDialogVisible = true;
      this.$nextTick(function () {
        if (_this4.$refs.articleForm) _this4.$refs.articleForm.clearValidate();
      });
    },
    onArticleEdit: function onArticleEdit(row) {
      var _this5 = this;

      this.articleForm = {
        id: row.id,
        channel_id: row.channel_id,
        title: row.title,
        cover: row.cover || '',
        desc: row.desc || '',
        content: row.content || '',
        is_recommend: row.is_recommend,
        status: row.status,
        sort: row.sort
      };
      this.articleDialogVisible = true;
      this.$nextTick(function () {
        if (_this5.$refs.articleForm) _this5.$refs.articleForm.clearValidate();
      });
    },
    onArticleSubmit: function onArticleSubmit() {
      var _this6 = this;

      this.$refs.articleForm.validate(function (valid) {
        if (!valid) return;
        _this6.articleSubmitLoading = true;

        var data = _objectSpread({}, _this6.articleForm);

        articleHandle(data).then(function (res) {
          _this6.$message({
            message: _this6.articleForm.id ? '编辑成功' : '新增成功',
            type: 'success'
          });

          _this6.articleDialogVisible = false;
          _this6.articleSubmitLoading = false;

          _this6.loadArticleList();
        }).catch(function () {
          _this6.articleSubmitLoading = false;
        });
      });
    },
    onArticleDelete: function onArticleDelete(row) {
      var _this7 = this;

      this.$confirm('确定删除该文章？', '提示', {
        type: 'warning'
      }).then(function () {
        articleDelete({
          id: row.id
        }).then(function () {
          _this7.$message({
            message: '删除成功',
            type: 'success'
          });

          _this7.loadArticleList();
        });
      }).catch(function () {});
    },
    // 频道新增/编辑
    onChannelAdd: function onChannelAdd() {
      var _this8 = this;

      this.channelForm = {
        id: '',
        name: '',
        sort: 0,
        is_show: 1,
        is_recommend: 0
      };
      this.channelDialogVisible = true;
      this.$nextTick(function () {
        if (_this8.$refs.channelForm) _this8.$refs.channelForm.clearValidate();
      });
    },
    onChannelEdit: function onChannelEdit(row) {
      var _this9 = this;

      this.channelForm = _objectSpread({}, row);
      this.channelDialogVisible = true;
      this.$nextTick(function () {
        if (_this9.$refs.channelForm) _this9.$refs.channelForm.clearValidate();
      });
    },
    onChannelSubmit: function onChannelSubmit() {
      var _this10 = this;

      this.$refs.channelForm.validate(function (valid) {
        if (!valid) return;
        _this10.channelSubmitLoading = true;

        var data = _objectSpread({}, _this10.channelForm);

        articleChannelHandle(data).then(function (res) {
          _this10.$message({
            message: _this10.channelForm.id ? '编辑成功' : '新增成功',
            type: 'success'
          });

          _this10.channelDialogVisible = false;
          _this10.channelSubmitLoading = false;

          _this10.loadChannelList().then(function () {
            _this10.loadArticleList();
          });
        }).catch(function () {
          _this10.channelSubmitLoading = false;
        });
      });
    },
    onChannelDelete: function onChannelDelete(row) {
      var _this11 = this;

      this.$confirm('删除频道会下线该频道下所有文章，确定删除？', '提示', {
        type: 'warning'
      }).then(function () {
        articleChannelDelete({
          id: row.id
        }).then(function () {
          _this11.$message({
            message: '删除成功',
            type: 'success'
          });

          _this11.loadChannelList();
        });
      }).catch(function () {});
    },
    // 封面上传
    onBeforeUpload: function onBeforeUpload(file) {
      var isImage = file.type.startsWith('image/');

      if (!isImage) {
        this.$message.error('只能上传图片文件');
      }

      return isImage;
    },
    onCoverUpload: function onCoverUpload(option) {
      upload.upload(option, {
        type: 'article'
      });
    },
    onCoverUploadSuccess: function onCoverUploadSuccess(response) {
      if (response && response.url) {
        this.$set(this.articleForm, 'cover', response.url);
      }
    }
  }
};